import { Tooltip, Typography } from '@mui/material';
import { trim } from 'lodash';
import React, { useMemo } from 'react';
import OrderWorkunit from 'types/entities/OrderWorkunit';

const DeliveryManagerCell = React.memo((row: OrderWorkunit) => {
  const getName = useMemo(() => {
    // Prefer delivery_manager array if present, else fallback to delivery_manager_fullname
    if (row.delivery_manager && row.delivery_manager[0]) {
      return trim(
        ` ${row.delivery_manager[0].last_name?.toUpperCase() || ''} ${row.delivery_manager[0].first_name || ''}`
      );
    }
    if (row.delivery_manager_fullname) {
      return row.delivery_manager_fullname;
    }
    return '';
  }, [row]);

  return (
    <Tooltip title={getName}>
      <Typography variant="body2" noWrap>
        {getName}
      </Typography>
    </Tooltip>
  );
});

export default DeliveryManagerCell;
